import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Teams from "../../api/Teams";

const BodyCell = props => {
  const { cellSize, backgroundVariant, alignText, children, className } = props;

  const teamColor1 = Teams.currentTeamColorLevel1();
  const disabledColor = "hsla(202, 100%, 8%, 0.02)";
  const defaultHighlightedColor = "rgb(141, 217, 222)";

  const backgroundColor =
    backgroundVariant === "default"
      ? "$color-white"
      : backgroundVariant === "disabled"
        ? disabledColor
        : teamColor1
          ? teamColor1
          : defaultHighlightedColor;

  return (
    <td className={className}>
      <div
        className={cn(
          "responsive-table__cell",
          `responsive-table__cell_${alignText}`,
          `responsive-table__cell_${cellSize}`
        )}
        style={{ backgroundColor: backgroundColor }}
      >
        {" "}
        {children}
      </div>
    </td>
  );
};

BodyCell.defaultProps = {
  alignText: "center",
  isGrow: true,
  backgroundVariant: "default",
  cellSize: "medium"
};

BodyCell.propsType = {
  alignText: PropTypes.oneOf(["left", "right", "center"]),
  backgroundVariant: PropTypes.oneOf(["default", "highlighted", "disabled"]),
  cellSize: PropTypes.oneOf(["small", "medium"]),
  isGrow: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

export default BodyCell;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/body-cell.js